import { getMerchantToken } from "./merchantAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_MERCHANT_API_BASE_URL ||
  "http://secondbite-manage.localhost/merchant-api/v1"
).replace(/\/+$/, "");

const request = async (path, options = {}) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getMerchantToken()}`,
        ...(options.headers || {}),
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors ? Object.values(payload.errors).flat()[0] : null;
    throw new Error(validationMessage || payload?.message || "Unable to load orders.");
  }
  return payload.data;
};

const queryString = (filters = {}) => {
  const query = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") query.set(key, value);
  });
  return query.toString();
};

export const getMerchantOrders = (filters) =>
  request(`/orders?${queryString(filters)}`);

export const getMerchantOrder = (orderNumber) =>
  request(`/orders/${encodeURIComponent(orderNumber)}`);

export const collectMerchantOrder = (orderNumber) =>
  request(`/orders/${encodeURIComponent(orderNumber)}/collect`, { method: "PATCH" });

export const cancelMerchantOrder = (orderNumber, data) =>
  request(`/orders/${encodeURIComponent(orderNumber)}/cancel`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });

export const exportMerchantOrders = async (filters) => {
  const response = await fetch(`${API_BASE_URL}/orders/export?${queryString(filters)}`, {
    headers: {
      Accept: "text/csv",
      Authorization: `Bearer ${getMerchantToken()}`,
    },
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.message || "Unable to export orders.");
  }
  return response.blob();
};
